
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class MaterialCard extends Vue {
    @Prop({ type: String, default: '' }) private readonly avatar!: string
    @Prop({ type: String, default: 'success' }) private readonly color!: string
    @Prop({ type: Boolean, default: false }) private readonly hoverReveal!: boolean
    @Prop({ type: String, default: undefined }) private readonly icon!: string
    @Prop({ type: Boolean, default: false }) private readonly image!: boolean
    @Prop({ type: Boolean, default: false }) private readonly inline!: boolean
    @Prop({ type: String, default: '' }) private readonly text!: string
    @Prop({ type: String, default: '' }) private readonly title!: string

    get classes(): {[key: string]: boolean} {
      return {
        'v-card--material--has-heading': this.hasHeading,
        'v-card--material--hover-reveal': this.hoverReveal,
      }
    }

    get hasHeading(): boolean {
      return Boolean(this.$slots.heading || this.title || this.icon)
    }

    get hasAltHeading(): boolean {
      return Boolean(this.$slots.heading || (this.title && this.icon))
    }
  }
